module.exports = __webpack_public_path__ + "img/female-figure-sitting.afd5d174.svg";